import type { CreatePaymentMethodReq } from '../../../services/customer/types';
import type { Agent } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

export function createPaymentMethodRequest(
  tokenizedCardId: string,
  isDefault: boolean,
  nickname: string,
  name: string,
  isManufacturerCard: boolean,
  agent: Agent | null,
): Record<'paymentMethod', CreatePaymentMethodReq> {
  return {
    paymentMethod: {
      type: 'CARD',
      vendorPaymentMethodId: tokenizedCardId,
      vendor: 'STRIPE',
      default: isDefault,
      nickname,
      paymentMethodDetails: {
        type: 'CARD',
        nameOnCard: name,
        manufacturerCard: isManufacturerCard,
      },
      sourceProvider: {
        name: 'CCG',
      },
      agent,
      authRequired: true,
      paymentMethodSourceDetails: {
        channel: 'WEBFORM',
        uiSourceFragment: 'STRIPE',
      },
    },
  };
}
